var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "syf-component-library/ui/atoms";
import Tooltip from "syf-component-library/ui/atoms/Tooltip";
import { Inline, Inset, Stack } from "syf-component-library/ui/spacing";
import { Body } from "syf-component-library/ui/typography";
import { formatDisplayDateWithFormat } from "syf-js-utilities";
import { useTranslation } from "react-i18next";
import CreditChangeSection from "./CreditChangeSection";
import { ButtonWrapper, CreditHeaderWrapper, CreditInfoWrapper, CreditScoreText, CreditStatusText, ScoreInfoWrapper, ScoreTitleWrapper, } from "./subcomponents";
import links from "../../../../const/links";
import modalIds from "../../../../const/modalIds";
import { useVantageContext } from "../../../../context/vantageContext";
import ScoreChart from "../../../atoms/ScoreChart";
import VantageLink from "../../../atoms/VantageLink";
import VantageTrans from "../../../atoms/VantageTrans";
import QuestionsAboutCreditScore from "../QuestionsAboutCreditScore";
import ToolTipPopUp from "../ToolTipPopUp";
import getCreditStatus from "../../../../helpers/getCreditStatus";
var CreditHeader = function (_a) {
    var _b, _c, _d, _e;
    var enrolledAccountDetails = _a.enrolledAccountDetails;
    var t = useTranslation().t;
    var isCrossBorderVisible = useVantageContext().state.isCrossBorderVisible;
    var isOnlyOneMonthData = ((_b = enrolledAccountDetails.scores) === null || _b === void 0 ? void 0 : _b.length) === 1;
    var _f = useState({
        isOpen: false,
        containerId: "",
    }), creditQuestionsModal = _f[0], setCreditQuestionsModal = _f[1];
    var _g = useState({
        isOpen: false,
        containerId: "",
    }), creditToolTipModal = _g[0], setCreditToolTipModal = _g[1];
    var openCreditQuestionsModal = function (id) {
        setCreditQuestionsModal({
            isOpen: true,
            containerId: id,
        });
    };
    var closeCreditQuestionsModal = function () {
        setCreditQuestionsModal({
            isOpen: false,
            containerId: "",
        });
    };
    useEffect(function () {
        if (isCrossBorderVisible) {
            closeCreditQuestionsModal();
        }
    }, [isCrossBorderVisible]);
    var openCreditToolTipModal = function () {
        setCreditToolTipModal({
            isOpen: true,
            containerId: modalIds.TOOLTIP_MODAL_ID,
        });
    };
    var closeCreditToolTipModal = function () {
        setCreditToolTipModal({
            isOpen: false,
            containerId: "",
        });
    };
    var latestScore;
    if ((_c = enrolledAccountDetails === null || enrolledAccountDetails === void 0 ? void 0 : enrolledAccountDetails.scores) === null || _c === void 0 ? void 0 : _c[0]) {
        latestScore = (_d = enrolledAccountDetails === null || enrolledAccountDetails === void 0 ? void 0 : enrolledAccountDetails.scores) === null || _d === void 0 ? void 0 : _d[0];
    }
    else {
        throw new Error("missing latest score");
    }
    var creditStatusText = getCreditStatus(latestScore.creditScore);
    return (_jsxs(CreditHeaderWrapper, __assign({ id: modalIds.CROSS_BORDER_MODAL_ID }, { children: [_jsx(ScoreTitleWrapper, __assign({ as: "h2", weight: "semiBold" }, { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.headerSection.score" }) })), _jsx(CreditScoreText, { children: latestScore.creditScore }), _jsxs(CreditInfoWrapper, { children: [creditStatusText && (_jsx(CreditStatusText, __assign({ as: "p", weight: "semiBold" }, { children: t("creditStatus.".concat(creditStatusText)) }))), _jsx(Inline, { size: "small" }), _jsx(Tooltip, __assign({ placement: "top-start", id: "credit-score-tooltip", isInteractive: true, content: "" }, { children: _jsx("div", { children: _jsx(FontAwesomeIcon, { color: "#34657F", size: "lg", icon: faCircleInfo, onClick: openCreditToolTipModal }) }) })), !isOnlyOneMonthData && (_jsx(CreditChangeSection, { creditScores: enrolledAccountDetails.scores }))] }), _jsx(ToolTipPopUp, { isOpen: creditToolTipModal.isOpen, closeModal: closeCreditToolTipModal }), _jsx(Stack, { size: "medium" }), _jsxs(Body, { children: [_jsx(VantageTrans, { i18nKey: "creditScorePage.headerSection.updatedOn" }), " ", formatDisplayDateWithFormat((_e = latestScore === null || latestScore === void 0 ? void 0 : latestScore.generatedDate) !== null && _e !== void 0 ? _e : "", "MM/dd/yyyy")] }), _jsx(Inline, {}), enrolledAccountDetails.scores.length > 1 && (_jsx(ScoreChart, { enrolledAccountDetails: enrolledAccountDetails })), _jsx(Stack, { size: "large" }), _jsx(Inset, __assign({ all: "small" }, { children: _jsx(ScoreInfoWrapper, { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.headerSection.creditScoreInfo", components: {
                            link1: _jsx(VantageLink, { to: links.TRANS_UNION_LINK, isExternal: true }),
                        } }) }) })), _jsx(Stack, { size: "large" }), _jsx(ButtonWrapper, { children: _jsx(Button, __assign({ buttonType: "primary", onClick: function () {
                        return openCreditQuestionsModal(modalIds.QUESTIONS_ABOUT_CREDIT_SCORE_MODAL_ID);
                    }, type: "button", "data-type": "credit score", "data-analytics": "clicktrackingevent", "data-reason": "see a problem with your score ?" }, { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.buttons.problemWithScore" }) })) }), _jsx(QuestionsAboutCreditScore, { isOpen: creditQuestionsModal.isOpen, onClose: function () { return closeCreditQuestionsModal(); } })] })));
};
export default CreditHeader;
